import React from 'react'
import './FunctionalBox.scss'

const FunctionalBox = ({className, IconImg ,Img, heading, para}) => {
    return (
        <div className={className}>
            <div className='functionalities-lefteach-container'>
                <img src={IconImg} alt='' />
                <h2>{heading}</h2>
                <p>{para}</p>
                <button className='theme-Btn-bg'><span>Read More</span></button>
            </div>
            <div className='functionalities-righteach-container'>
                <img src={Img} alt='' />
            </div>
        </div>
    )
}

export default FunctionalBox